import { NormalizedNumber } from '@sparkdotfi/common-universal'

import { Token, USD_MOCK_TOKEN } from '@/domain/types/Token'
import { assets } from '@/ui/assets'
import HandCoinsIcon from '@/ui/assets/hand-coins.svg?react'
import { Button } from '@/ui/atoms/button/Button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuItemIcon,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/ui/atoms/dropdown/DropdownMenu'
import { testIds } from '@/ui/utils/testIds'

export interface Reward {
  token: Token
  amount: NormalizedNumber
}

export interface TopbarRewardsProps {
  rewards: Reward[]
  onClaim: () => void
  totalClaimableReward: NormalizedNumber
}
export function TopbarRewards({ rewards, onClaim, totalClaimableReward }: TopbarRewardsProps) {
  if (totalClaimableReward.isZero()) {
    return null
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          data-testid={testIds.topbar.rewards.badge}
          size="m"
          variant="tertiary"
          className="aspect-square top-bar-xl:aspect-auto"
        >
          <img src={assets.giftGradient} alt="Gift icon" className="h-6" />
          <span data-testid={testIds.topbar.rewards.claimableRewards} className="top-bar-xl:block hidden">
            {USD_MOCK_TOKEN.formatUSD(totalClaimableReward, { compact: true })}
          </span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-80 p-1" data-testid={testIds.topbar.rewards.details.dropdown}>
        <DropdownMenuGroup className="py-2">
          <DropdownMenuLabel>Rewards</DropdownMenuLabel>

          {rewards.map(({ token, amount }, index) => (
            <DropdownMenuItem
              className="pointer-events-none justify-between py-2"
              key={token.symbol}
              data-testid={testIds.topbar.rewards.details.row(index)}
            >
              <div className="flex items-center gap-2">
                <img src={token.logo} alt={`${token.symbol} icon`} className="h-6" />

                <div className="typography-label-2">
                  <span data-testid={testIds.topbar.rewards.details.amount}>
                    {token.format(amount, { style: 'auto' })}
                  </span>{' '}
                  <span data-testid={testIds.topbar.rewards.details.token}>{token.symbol}</span>
                </div>
              </div>

              <div className="typography-label-4 text-secondary" data-testid={testIds.topbar.rewards.details.amountUSD}>
                {token.formatUSD(amount)}
              </div>
            </DropdownMenuItem>
          ))}
        </DropdownMenuGroup>
        <DropdownMenuSeparator />
        <DropdownMenuItem asChild>
          <button className="cursor-pointer" onClick={onClaim}>
            <DropdownMenuItemIcon icon={HandCoinsIcon} />
            Claim rewards
          </button>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
